export default __webpack_public_path__ + "static/media/main_footer_guide.2a3cfd08.svg";